import { RiskLevel } from '@equip.health/ui';

import { SurveyName } from '~/lib/constants/survey/SurveyName';
import { SurveyNameToChartPrimaryKeyMap } from '~/lib/constants/survey/SurveyNameToChartPrimaryKeyMap';
import { SurveyNameToSurveyKeyMap } from '~/lib/constants/survey/SurveyNameToSurveyKeyMap';
import { sumSpecificKeys } from '~/lib/util/survey.util';

const sumAimsQuestionsWithCodeStructure = (
  jsonResultsObj: unknown,
  questionKeys: string[],
) => {
  let result = 0;
  questionKeys.forEach((questionKey) => {
    result += jsonResultsObj[questionKey]?.[0]?.Code || 0;
  });
  return result;
};
export const deriveAIMSScores = (jsonResults: string) => {
  const resultsObj = JSON.parse(jsonResults);
  const qKey = SurveyNameToSurveyKeyMap[SurveyName.AIMS];

  const s1 = sumAimsQuestionsWithCodeStructure(resultsObj, [
    `${qKey}_1`,
    `${qKey}_2`,
    `${qKey}_3`,
    `${qKey}_4`,
  ]);

  const s2 = sumAimsQuestionsWithCodeStructure(resultsObj, [
    `${qKey}_5`,
    `${qKey}_6`,
    `${qKey}_7`,
  ]);

  const s3 = sumSpecificKeys(jsonResults, [
    `${qKey}_8`,
    `${qKey}_9`,
    `${qKey}_10`,
  ]);

  let riskLevel: RiskLevel = RiskLevel.NOT_CALCULATED;
  const riskNumber = resultsObj[`${qKey}_8`];
  if (riskNumber === 0) {
    riskLevel = RiskLevel.NONE;
  } else if (riskNumber === 1) {
    riskLevel = RiskLevel.LOW;
  } else if (riskNumber === 2) {
    riskLevel = RiskLevel.MILD;
  } else if (riskNumber === 3) {
    riskLevel = RiskLevel.MODERATE;
  } else if (riskNumber === 4) {
    riskLevel = RiskLevel.HIGH;
  }

  return {
    [SurveyNameToChartPrimaryKeyMap[SurveyName.AIMS]]: s1 + s2,
    ['Orofacial movements (S1)']: s1,
    ['Extremity & truncal dyskinesia (S2)']: s2,
    ['Global severity (S3)']: s3,
    riskLevel,
  };
};
